import React, { useState, useEffect } from "react";
import api from "api/api";

// mui component
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";

import Slide from "@mui/material/Slide";
import DialogContentText from "@mui/material/DialogContentText";

// icon
import CloseIcon from "@mui/icons-material/Close";

import { useSelector, useDispatch } from "react-redux";
import { showNotification } from "store/features/notificationSlice";

//Props Validations
import PropTypes from "prop-types";

const Transition = React.forwardRef(function Transition(props, ref) {
    return (
        <Slide
            direction="up"
            ref={ref}
            {...props}
        />
    );
});

function TagsAddUpdateComponent({ title = "", type = "", selectedRows = [], isOpen = false, setIsAddDialogOpen = () => {}, setIsUpdateDialogOpen = () => {}, fetchData = () => {}, selectedStudyType = {}, selectedStudyTypeMethod = [] }) {
    const dispatch = useDispatch();
    // add dialog confirmation
    const [isConfirmationDialogOpen, setIsConfirmationDialogOpen] = useState(false);

    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);
    const productCategoryId = productCategoryData?.value || null;

    const [data, setData] = useState({
        title: "",
    });

    const setUpdatedData = () => {
        if (type === "update") {
            setData({
                title: selectedRows.title,
            });
        }
    };

    useEffect(() => {
        setUpdatedData();
    }, []);

    const handleReset = () => {
        if (type === "add") {
            setData({
                title: "",
            });
        } else if (type === "update") {
            setUpdatedData();
        }
    };
    const handleSave = () => {
        const isValid = validateInputs();
        if (isValid) {
            let payload = {
                ...data,
                description: data?.title || "",
            };
            const studyTypeMethods = [...new Set(selectedStudyTypeMethod.map((datum) => datum.value))];

            if (type === "add") {
                if (productCategoryId && selectedStudyType?.value && studyTypeMethods.length > 0) {
                    payload = { ...payload, product_category: productCategoryId, study_type: selectedStudyType.value, study_type_methods: studyTypeMethods };
                    try {
                        const url = process.env.REACT_APP_SERVER_PATH + `/claims-tags/`;
                        api.post(url, payload)
                            .then(() => {
                                fetchData();
                                handleClose();
                                handleConfirmationDialogClose();
                            })
                            .catch((error) => {
                                handleError("error", error);
                                handleConfirmationDialogClose();
                            });
                    } catch (error) {
                        handleError("error", error);
                        handleConfirmationDialogClose();
                    }
                } else {
                    handleError("error", "Product category / study type / study type methods are not selected");
                }
            } else if (type === "update") {
                if (productCategoryId && selectedStudyType?.value && studyTypeMethods.length > 0) {
                    payload = { ...payload, product_category: productCategoryId, study_type: selectedStudyType.value, study_type_methods: studyTypeMethods };
                    try {
                        const url = process.env.REACT_APP_SERVER_PATH + `/claims-tags/${selectedRows.id}/`;
                        api.put(url, payload)
                            .then(() => {
                                fetchData();
                                handleClose();
                                handleConfirmationDialogClose();
                            })
                            .catch((error) => {
                                handleError("error", error);
                                handleConfirmationDialogClose();
                            });
                    } catch (error) {
                        handleError("error", error);
                        handleConfirmationDialogClose();
                    }
                } else {
                    handleError("error", "Product category / Study type / Study type methods are not selected");
                }
            }
        } else {
            handleError("warning", "Incomplete inputs fields.");
        }
    };

    const handleError = (type, error) => {
        dispatch(showNotification({ severity: type, data: error }));
    };
    const handleClose = () => {
        handleReset();
        setIsAddDialogOpen(false);
        setIsUpdateDialogOpen(false);
    };

    const validateInputs = () => {
        if (data.title) {
            return true;
        } else {
            return false;
        }
    };

    const handleInputValueChange = (selectedValue, type, fieldId) => {
        if (type === "dropdown") {
            if (selectedValue.length !== 0 && selectedValue.every((datum) => datum.value && datum.label.trim() !== "")) {
                setData({
                    ...data,
                    [fieldId]: selectedValue,
                });
            } else {
                setData({
                    ...data,
                    [fieldId]: "",
                });
            }
        } else if (type === "text") {
            if (selectedValue && selectedValue !== "") {
                setData({
                    ...data,
                    [fieldId]: selectedValue,
                });
            } else {
                setData({
                    ...data,
                    [fieldId]: "",
                });
            }
        }
    };

    const handleConfirmationDialogClose = () => {
        setIsConfirmationDialogOpen(false);
    };

    return (
        <>
            <Dialog
                aria-labelledby="customized-dialog-title"
                open={isOpen}
                fullWidth={true}
                maxWidth={"sm"}
            >
                <DialogTitle
                    style={{
                        backgroundColor: "rgb(51, 94, 234,0.1)",
                        color: "rgb(51, 94, 234)",
                        fontSize: 15,
                        textAlign: "center",
                        padding: "10px 12px",
                    }}
                    // className="liner-light-blue-background-2"
                    id="customized-dialog-title"
                >
                    {title}
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 2,
                        color: "rgb(51, 94, 234) !important",
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <div className="row pb-2">
                        <div className="col-2">
                            <label className="input-label vertical-center text-sm ">Title :</label>
                        </div>
                        <div className="col-10">
                            <input
                                type="text"
                                id="type"
                                value={data.title}
                                className="input-label-field text-sm"
                                onChange={(e) => handleInputValueChange(e.target.value, "text", "title")}
                            />
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button
                        className="custom-btn"
                        variant="outlined"
                        size="small"
                        onClick={handleReset}
                    >
                        Reset
                    </Button>
                    <Button
                        className="custom-btn liner-light-blue-background me-3"
                        size="small"
                        autoFocus
                        variant="contained"
                        color="primary"
                        onClick={() => setIsConfirmationDialogOpen(true)}
                    >
                        {type === "add" ? "Add" : "Update"}
                    </Button>
                </DialogActions>
            </Dialog>
            {isConfirmationDialogOpen && (
                <Dialog
                    open={isConfirmationDialogOpen}
                    TransitionComponent={Transition}
                    keepMounted
                    // onClose={handleArchiveClickClose}
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle className="text-base">Confirm {type === "add" ? "adding" : "updating"} this tag</DialogTitle>
                    <DialogContent>
                        <DialogContentText
                            className="text-sm"
                            id="alert-dialog-slide-description"
                        >
                            Are you sure you want to {type === "add" ? "add" : "update"} this tag?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            className="me-2 custom-btn"
                            size="small"
                            variant="contained"
                            color="error"
                            onClick={handleConfirmationDialogClose}
                        >
                            Disagree
                        </Button>
                        <Button
                            className="me-2 custom-btn liner-light-blue-background"
                            size="small"
                            variant="contained"
                            onClick={handleSave}
                        >
                            Agree
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </>
    );
}

// Typechecking props
TagsAddUpdateComponent.propTypes = {
    title: PropTypes.string,
    type: PropTypes.string,
    tagsData: PropTypes.array,
    selectedRows: PropTypes.array,
    isOpen: PropTypes.bool,
    setIsAddDialogOpen: PropTypes.func,
    setIsUpdateDialogOpen: PropTypes.func,
    fetchData: PropTypes.func,
    selectedStudyType: PropTypes.object,
    selectedStudyTypeMethod: PropTypes.array,
};

export default TagsAddUpdateComponent;
